import { render, staticRenderFns } from "./ButacasPlanoGeneral.vue?vue&type=template&id=e6c27bdc&scoped=true"
import script from "./ButacasPlanoGeneral.vue?vue&type=script&lang=js"
export * from "./ButacasPlanoGeneral.vue?vue&type=script&lang=js"
import style0 from "./ButacasPlanoGeneral.vue?vue&type=style&index=0&id=e6c27bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c27bdc",
  null
  
)

export default component.exports